import { render } from "./PrivacyPolicy.vue?vue&type=template&id=d58c859e"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appleuser/Documents/projets/complaints-management-crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__